import { HttpEventType } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { RouterLink } from '@angular/router';
import { FileService } from '../file/file.service';
import { BaseComponent } from '../shared/base.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
    selector: 'app-mission-planner',
    standalone: true,
    imports: [
        SiteHeaderComponent,
        RouterLink
    ],
    templateUrl: './mission-planner.component.html',
    styleUrl: './mission-planner.component.css'
})
export class MissionPlannerComponent extends BaseComponent {

    private fileService: FileService = inject(FileService);

    private static _downloadingFirmwareFile = "Downloading Mission Planner Install";
    private static _downloadingFirmwareFileError = `${MissionPlannerComponent._downloadingFirmwareFile} error:`;

    public async downloadMpInstall() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const observable = this.fileService.getDownloadUrl(await getIdToken(currentUser), "mission-planner");
            super.showSnackBar(`${MissionPlannerComponent._downloadingFirmwareFile}...`, -1);

            try {
                observable.subscribe(response => {
                    const json = JSON.parse(JSON.stringify(response));

                    if (json["get-mission-planner-download-url"] == "success") {
                        this.initiateDownload(json.url, json["file-name"]);
                    } else {
                        throw new Error(json["message"]);
                    }
                });
            } catch (error) {
                const message = `${MissionPlannerComponent._downloadingFirmwareFileError} ${(<Error>error).message}`;
                console.error(message);
                super.showSnackBar(message, 30);
           }
        } else {
            const message = `${MissionPlannerComponent._downloadingFirmwareFileError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }

    private async initiateDownload(url: string, fileName: string) {
        const observable = this.fileService.downloadFile(url);
        const downloadSub = observable.subscribe(event => {
            try {
                switch (event.type) {
                    case HttpEventType.Sent:
                        break;
                    case HttpEventType.ResponseHeader:
                        break;
                    case HttpEventType.DownloadProgress:
                        /*
                        let percentDone = 0;
                        if (event.total != undefined) {
                            percentDone = Math.round(100 * event.loaded / event.total);
                        }
                        console.firmware(`Download progress: ${percentDone}%`);
                        */
                        break;
                    case HttpEventType.Response:
                        if (event.status == 200) {
                            const blob = new Blob([event.body as BlobPart], { type: 'application/octet-stream' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName; 
                            link.click();
                            link.remove();
                            this.showSnackBar(`Download completed.`);
                        } else {
                            throw new Error(`Download failed, status: ${event.status}, statusText: ${event.statusText}`)
                        }
                        break;
                }
            } catch (error) {
                const message = `${MissionPlannerComponent._downloadingFirmwareFileError} ${(<Error>error).message}`;
                console.error(message);
                super.showSnackBar(message, 30);
            }
        });
    }
}
